// extracted by mini-css-extract-plugin
module.exports = {"gallery-container":"GalleryLabel_gallery-container__ddtbg","gallery-count":"GalleryLabel_gallery-count__madvY"};